import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenerativeSearchRequest, GenerativeSearchResponse, HybridSearchRequest, SearchRequest, SearchResponse, SemanticSearchRequest, SemanticSearchRequestV2, SearchResponseV2 } from '../../_shared/models/intelligentSearch';


@Injectable({
  providedIn: 'root'
})

export class IntelligentSearchService {
  private headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  constructor(private http: HttpClient,
    @Inject('BASE_URL') private baseUrlApi: string
  ) {
  }

  public keywordSearch(request: SearchRequest): Observable<SearchResponse> {
    return this.http.post<SearchResponse>(
      `${this.baseUrlApi}api/IntelligentSearch/keyword_search`,
      request,
      { headers: this.headers }
    );
  }

  public SemanticSearch(request: SemanticSearchRequest): Observable<SearchResponse> {
    return this.http.post<SearchResponse>(
      `${this.baseUrlApi}api/IntelligentSearch/semantic_search`,
      request,
      { headers: this.headers }
    );
  }

  public HybridSearch(request: HybridSearchRequest): Observable<SearchResponse> {
    return this.http.post<SearchResponse>(
      `${this.baseUrlApi}api/IntelligentSearch/hybrid_search_rrf`,
      request,
      { headers: this.headers }
    );
  }

  public GenerativeSearch(request: GenerativeSearchRequest): Observable<GenerativeSearchResponse> {
    return this.http.post<GenerativeSearchResponse>(
      `${this.baseUrlApi}api/IntelligentSearch/generative_search`,
      request,
      { headers: this.headers }
    );
  }

  public SemanticSearchV2(request: SemanticSearchRequestV2): Observable<SearchResponseV2> {
    return this.http.post<SearchResponseV2>(
      `${this.baseUrlApi}api/IntelligentSearch/v2/semantic_search`,
      request,
      { headers: this.headers }
    );
  }

}

